export default function FormatSSN(value: string) {
  var r = value.replace(/\D/g, "");
  if (r.length > 4) {
    r = r.replace(/^(\d{3})(\d{2})(\d{0,4}).*/, "$1-$2-$3");
  } else if (r.length > 2) {
    r = r.replace(/^(\d{3})(\d{0,3})/, "$1-$2");
  }
  if (r === value + '-') {
    // removing last minus symbol
    r = r.slice(0, -1);
  }
  return r;
}
